import * as Yup from "yup";
import { decideRCorBirthday, ID_TYPES, validateRCorBirthday } from "../../components/Identification/helpers";
import { StringSchema, ValidationError as YupValidationError } from "yup";
import { isValidBirthday } from "../../components/Identification/helpers/birtday.helpers";
import { isValidID } from "../../components/Identification/helpers/id.helpers";

export interface ValidationError {
  error: string;
}

function isValidationError(validation: any): validation is ValidationError {
  return typeof validation.error !== 'undefined';
}

Yup.addMethod<StringSchema>(Yup.string, "validateRCorBirthday", function(message: string) {

  return this.test('is-valid-id', message, (value, ctx) => {

    const typeofValue = decideRCorBirthday(value);

    if (typeofValue === ID_TYPES.DATE) {
      const validation = isValidBirthday(value);

      if (isValidationError(validation)) {
        return new YupValidationError(validation.error, value, ctx?.path);
      }
    }

    if (typeofValue === ID_TYPES.RC) {
      const validation = isValidID(value);
      if (isValidationError(validation)) {
        return new YupValidationError(validation.error, value, ctx?.path);
      }
    }

    return true;
  });
});
